import { EmailGatewayPage } from '@/features/settings/EmailGatewayPage';
import { platformEmailGatewayService } from './api/platform-email-gateway.api';

/**
 * Platform Console — Email Gateway Management.
 *
 * Intentionally a thin binding: the Service Provider gets the exact Gateway
 * Management screen tenants already have, driven by the platform API client
 * instead of the tenant one. No gateway UI is duplicated — the only additions
 * are the Backup gateway affordance and the routing explainer, both switched on
 * by `scope="PLATFORM"`.
 */
export function PlatformEmailGatewayPage() {
  return (
    <EmailGatewayPage
      service={platformEmailGatewayService}
      scope="PLATFORM"
      cacheKey="platform-email-gateways"
      showBackLink={false}
      title="Platform Email Gateways"
      subtitle="Fallback email delivery for companies that have not configured a gateway of their own. Set one Default and one Backup."
    />
  );
}
